"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes")),
    _utils = require("../../../common/utils"),
    _fileTypeIconMap = _interopRequireDefault(require("../../../common/constants/fileTypeIconMap"));

require("../styles/_manage-asset-modal.scss");

var IMAGE_SIZE = "50px",
    DELETE_KEYS = ["type", "size"];

function renderMetaData(metadata) {
  return Object.entries(metadata).map(function (metadataEntry) {
    var key = metadataEntry[0],
        value = metadataEntry[1];
    return DELETE_KEYS.includes(key) || "string" != typeof value ? null : _react["default"].createElement("p", {
      className: "manage-asset-modal__asset-info__text__additional-field",
      key: key
    }, "".concat(key, ": ").concat(value));
  }).filter(Boolean);
}

function getMetadataObject(metaData) {
  try {
    return JSON.parse(metaData);
  } catch (e) {
    return {};
  }
}

function FileInfo(asset) {
  var jsonMetadata = asset.metaData,
      filename = asset.filename,
      fileType = (0, _utils.getTypeFromAsset)(asset),
      icon = _fileTypeIconMap["default"][fileType],
      metaData = getMetadataObject(jsonMetadata);
  return _react["default"].createElement("div", {
    className: "manage-asset-modal__asset-info"
  }, _react["default"].createElement(_uiKit.Image, {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
    size: IMAGE_SIZE,
    defaultIconColour: "michael",
    defaultImageIcon: icon
  }), _react["default"].createElement("div", {
    className: "manage-asset-modal__asset-info__text"
  }, _react["default"].createElement("p", {
    className: "manage-asset-modal__asset-info__text__filename"
  }, _react["default"].createElement("strong", null, filename)), metaData.size || metaData.type ? _react["default"].createElement("div", {
    className: "manage-asset-modal__asset-info__text__metadata"
  }, _react["default"].createElement("p", null, metaData.type && "File type: ".concat(metaData.type)), _react["default"].createElement("p", null, metaData.size && " - ".concat((0, _getDisplayBytes["default"])(metaData.size)))) : null, renderMetaData(metaData)));
}

var _default = (0, _react.memo)(FileInfo);

exports["default"] = _default;